export default __webpack_public_path__ + "static/media/feature-3-treatments.177d480b.svg";